// extracted by mini-css-extract-plugin
export var image = "TextImage-module--image--0d01d";
export var imageWrapper = "TextImage-module--imageWrapper--629e9";
export var imageWrapperStuck = "TextImage-module--imageWrapperStuck--d2d1a";
export var isToLeft = "TextImage-module--isToLeft--2919e";
export var isToRight = "TextImage-module--isToRight--ec6ff";
export var moduleWrapper = "TextImage-module--moduleWrapper--ca6fc";
export var row = "TextImage-module--row--95209";
export var rowStuck = "TextImage-module--rowStuck--a302c";
export var video = "TextImage-module--video--a22c9";